<div class="api-comparison-panel" [class.minimized]="isMinimized">
  <!-- Header -->
  <div class="panel-header" (click)="toggleMinimized()">
    <div class="header-title">
      <span class="icon">🔄</span>
      <span class="title">API Comparison</span>
    </div>
    <div class="header-stats">
      <span class="stat stat-total">{{ stats.total }}</span>
      <span class="stat stat-ok">✓{{ stats.passed }}</span>
      <span class="stat stat-ko">✗{{ stats.failed }}</span>
    </div>
    <button class="toggle-btn">{{ isMinimized ? '▲' : '▼' }}</button>
  </div>

  <!-- Body (visible when not minimized) -->
  <div class="panel-body" *ngIf="!isMinimized">
    <!-- Filters -->
    <div class="filters">
      <button
        class="filter-btn"
        [class.active]="filter === 'all'"
        (click)="setFilter('all')">
        All ({{ stats.total }})
      </button>
      <button
        class="filter-btn filter-ok"
        [class.active]="filter === 'ok'"
        (click)="setFilter('ok')">
        OK ({{ stats.passed }})
      </button>
      <button
        class="filter-btn filter-ko"
        [class.active]="filter === 'ko'"
        (click)="setFilter('ko')">
        KO ({{ stats.failed }})
      </button>
      <button class="clear-btn" (click)="clearResults()">Clear</button>
    </div>

    <!-- Results list -->
    <div class="results-list">
      <div
        *ngFor="let result of filteredResults"
        class="result-item"
        [class.expanded]="isExpanded(result.id)">

        <!-- Result summary -->
        <div class="result-summary" (click)="toggleExpand(result.id)">
          <span class="status-badge" [ngClass]="getStatusClass(result)">
            {{ result.isMatch ? '✓' : '✗' }}
          </span>
          <span class="method" [ngClass]="getMethodClass(result.method)">
            {{ result.method }}
          </span>
          <span class="endpoint" [title]="result.endpoint">
            {{ result.endpoint | slice:0:30 }}{{ result.endpoint.length > 30 ? '...' : '' }}
          </span>
          <span class="duration">
            N:{{ formatDuration(result.nodeDuration) }} / P:{{ formatDuration(result.phpDuration) }}
          </span>
          <span class="timestamp">{{ formatTimestamp(result.timestamp) }}</span>
        </div>

        <!-- Result details (expanded) -->
        <div class="result-details" *ngIf="isExpanded(result.id)">
          <!-- URLs complètes avec boutons copier -->
          <div class="detail-section url-section">
            <div class="url-row">
              <strong class="url-label node-label">Node.js:</strong>
              <code class="url-text">{{ getNodeUrl(result) }}</code>
              <button class="copy-btn" (click)="copyUrl(result, 'node', $event)" title="Copier l'URL">📋</button>
            </div>
            <div class="url-row">
              <strong class="url-label php-label">PHP:</strong>
              <code class="url-text">{{ getPhpUrl(result) }}</code>
              <button class="copy-btn" (click)="copyUrl(result, 'php', $event)" title="Copier l'URL">📋</button>
            </div>
          </div>

          <div class="detail-section">
            <strong>Status:</strong>
            Node {{ result.nodeStatus }} / PHP {{ result.phpStatus }}
            <span *ngIf="result.diff?.statusMismatch" class="error-text">(Mismatch!)</span>
          </div>

          <div class="detail-section" *ngIf="result.phpError">
            <strong>PHP Error:</strong>
            <span class="error-text">{{ result.phpError }}</span>
          </div>

          <div class="detail-section" *ngIf="result.diff?.structureDiff?.length">
            <strong>Structure Diff:</strong>
            <ul class="diff-list">
              <li *ngFor="let d of result.diff.structureDiff">{{ d }}</li>
            </ul>
          </div>
          <div class="detail-section" *ngIf="result.diff?.typeDiff?.length">
            <strong>Type Diff:</strong>
            <ul class="diff-list">
              <li *ngFor="let d of result.diff.typeDiff">{{ d }}</li>
            </ul>
          </div>
          <div class="detail-section" *ngIf="result.diff?.valueDiff?.length">
            <strong>Value Diff:</strong>
            <ul class="diff-list">
              <li *ngFor="let d of result.diff.valueDiff">{{ d }}</li>
            </ul>
          </div>

          <!-- Boutons pour afficher les payloads -->
          <div class="payload-buttons">
            <button
              class="payload-btn node-btn"
              [class.active]="showPayload === 'node'"
              (click)="togglePayload('node')">
              Node Response
              <button class="copy-btn-small" (click)="copyPayload(result, 'node', $event)" title="Copier">📋</button>
            </button>
            <button
              class="payload-btn php-btn"
              [class.active]="showPayload === 'php'"
              (click)="togglePayload('php')">
              PHP Response
              <button class="copy-btn-small" (click)="copyPayload(result, 'php', $event)" title="Copier">📋</button>
            </button>
          </div>

          <!-- Affichage du payload Node.js -->
          <div class="payload-display" *ngIf="showPayload === 'node'">
            <pre>{{ formatJson(result.nodeResponse) }}</pre>
          </div>

          <!-- Affichage du payload PHP -->
          <div class="payload-display" *ngIf="showPayload === 'php'">
            <pre>{{ formatJson(result.phpResponse) }}</pre>
          </div>
        </div>
      </div>

      <!-- Empty state -->
      <div class="empty-state" *ngIf="filteredResults.length === 0">
        <p>Aucune comparaison {{ filter !== 'all' ? '(' + filter.toUpperCase() + ')' : '' }}</p>
      </div>
    </div>
  </div>
</div>
